import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useStore, useToast, useGrid, usePage, useResource } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_VHCL_MKER_MGMT_SRCH, SF_VHCL_MKER_MGMT_SRCH } from "./services/OsciVhclMkerMgmtService"; // 서비스
import { Link } from "react-router-dom";

/*
 * Vehicle Maker Management List
 * !== 차량 제조사 목록 ==!
 */
export const OSCI0105003Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0031" },
            { area: "comnCd", comnCd: "OSC0048" },
            { area: "comnCd", comnCd: "OSC0047" },
        ],
    });
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Vehicle Maker Management Search !== HS 관리 검색 ==!
        osciVhclMkerMgmt: useForm({
            defaultSchema: SF_VHCL_MKER_MGMT_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Vehicle Maker Management List !== HS 관리 목록 ==!
        osciVhclMkerMgmt: useGrid({
            defaultSchema: SG_VHCL_MKER_MGMT_SRCH,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const fetch = {
        getVhclMkerList: useFetch({
            api: (page = grid.osciVhclMkerMgmt.page) =>
                APIS.getVhclMkerList(form.osciVhclMkerMgmt.getValues(), page, grid.osciVhclMkerMgmt.size),
            enabled: comnUtils.isEmpty(form.osciVhclMkerMgmt.errors) && form.osciVhclMkerMgmt.isSubmitted,
            key: [grid.osciVhclMkerMgmt.page, grid.osciVhclMkerMgmt.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.osciVhclMkerMgmt.getValues(),
                    page: grid.osciVhclMkerMgmt.page,
                    size: grid.osciVhclMkerMgmt.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getVhclMkerList: () => {
            form.osciVhclMkerMgmt.handleSubmit(
                () => {
                    grid.osciVhclMkerMgmt.setPage(0);
                    fetch.getVhclMkerList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        osciVhclMkerMgmt: {
            head: {},
            cell: {
                vhclMkerCd: (props: any) => {
                    const { rowValues, value } = props;
                    return <Link to={`${URLS.osci0105006q}/${rowValues.vhclMkerCd}`}>{value}</Link>;
                },
            },
            edit: {},
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getVhclMkerList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.osciVhclMkerMgmt.schema.vhclMkerCd}></Group.Control>
                            <Group.Control {...form.osciVhclMkerMgmt.schema.vhclMkerNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.osciVhclMkerMgmt.reset();
                                    form.osciVhclMkerMgmt.setValues({ vhclMkerCd: "", vhclMkerNm: "" });
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getVhclMkerList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.osciVhclMkerMgmt.grid}
                            data={fetch.getVhclMkerList.data?.vhclMkerList}
                            render={render.osciVhclMkerMgmt}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        navigate(`${URLS.osci0105004s}`);
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
